var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalizationIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 23.625C3.88125 23.625 3.35175 23.4049 2.9115 22.9646C2.47125 22.5244 2.25075 21.9945 2.25 21.375V9C2.25 8.38125 2.4705 7.85175 2.9115 7.4115C3.3525 6.97125 3.882 6.75075 4.5 6.75H9V4.5C9 3.88125 9.2205 3.35175 9.6615 2.9115C10.1025 2.47125 10.632 2.25075 11.25 2.25H15.75C16.3687 2.25 16.8986 2.4705 17.3396 2.9115C17.7806 3.3525 18.0007 3.882 18 4.5V6.75H22.5C23.1187 6.75 23.6486 6.9705 24.0896 7.4115C24.5306 7.8525 24.7507 8.382 24.75 9V21.375C24.75 21.9937 24.5299 22.5236 24.0896 22.9646C23.6494 23.4056 23.1195 23.6257 22.5 23.625H4.5ZM4.5 21.375H22.5V9H4.5V21.375ZM11.25 6.75H15.75V4.5H11.25V6.75Z",
    fill: "#2783EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizationIcon2);
export default __webpack_public_path__ + "static/media/personalization-icon2.a6df7851856feb8bbf054aa232914ddc.svg";
export { ForwardRef as ReactComponent };